import storage from 'redux-persist/lib/storage'; // Import the storage engine (localStorage in this case)

const persistConfig = {
    key: 'root',
    storage,
};

export default persistConfig;
